import { COLUMN_WIDTH, ROW_HEIGHT } from "../AppForm/constants";
import { AppPartType } from "../AppForm/types";

interface IProps {
  item: AppPartType;
}

const VerticalBorder = (props: IProps) => {
  const { item } = props;
  const { w, h, x, y } = item.item_config_data;
  const width = w * COLUMN_WIDTH;
  const height = h * ROW_HEIGHT;
  const level_border = item.item_config_data?.level_vertical || 0;
  const width_border = COLUMN_WIDTH * level_border || 1;
  return (
    <div
      style={{
        display: "flex",
        height,
        width,
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "black",
          width: width_border,
          height: "100%",
        }}
      ></div>
    </div>
  );
};
export default VerticalBorder;
